<template>
  <div class="lds-spinner" :style="cssProps">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
  const SIZE_TO_COEF = {
    large: 1,
    medium: 5 / 6,
    small: 2 / 3,
  };

  export default {
    name: 'Spinner',
    props: {
      color: {
        type: String,
        default: 'black',
      },
      size: {
        type: String,
        default: 'medium',
        validator: (size) => ['large', 'medium', 'small'].includes(size),
      },
    },
    computed: {
      cssProps() {
        return {
          '--spinner-color': this.color,
          '--spinner-width': '2px',
          '--spinner-height': '6px',
          '--spinner-size': '24px',
          '--spinner-c': SIZE_TO_COEF[this.size],
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .lds-spinner {
    display: inline-block;
    position: relative;
    width: calc(var(--spinner-size) * var(--spinner-c));
    height: calc(var(--spinner-size) * var(--spinner-c));
  }
  .lds-spinner div {
    transform-origin: calc(var(--spinner-size) / 2 * var(--spinner-c))
      calc(var(--spinner-size) / 2 * var(--spinner-c));
    animation: lds-spinner 1.2s linear infinite;
  }
  .lds-spinner div:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 1px;
    left: calc(var(--spinner-size) / 2 * var(--spinner-c) - 1px);
    width: calc(var(--spinner-width) * var(--spinner-c));
    height: calc(var(--spinner-height) * var(--spinner-c));
    border-radius: 20%;
    background: var(--spinner-color);
  }
  .lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -0.7s;
  }
  .lds-spinner div:nth-child(2) {
    transform: rotate(45deg);
    animation-delay: -0.6s;
  }
  .lds-spinner div:nth-child(3) {
    transform: rotate(90deg);
    animation-delay: -0.5s;
  }
  .lds-spinner div:nth-child(4) {
    transform: rotate(135deg);
    animation-delay: -0.4s;
  }
  .lds-spinner div:nth-child(5) {
    transform: rotate(180deg);
    animation-delay: -0.3s;
  }
  .lds-spinner div:nth-child(6) {
    transform: rotate(225deg);
    animation-delay: -0.2s;
  }
  .lds-spinner div:nth-child(7) {
    transform: rotate(270deg);
    animation-delay: -0.1s;
  }
  .lds-spinner div:nth-child(8) {
    transform: rotate(315deg);
    animation-delay: 0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>
